import {Fragment, useState, useEffect} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {useDataTable} from '../../../../shared/hooks/DataTable';
import {FormatDisplay} from '../../../../shared/format';

import {ToastService} from '../../../../AppToast';
import {ConfirmDialogService} from '../../../../AppConfirmDialog';

import {PetrolimexService} from '../PetrolimexService';
import {useTranslation} from '../../../../shared/language';

export const DialogViewHistory = (props) => {


  const {display, setDisplay, selectedItem} = props;
  const {t} = useTranslation();

  const [requiredParams, setRequiredParams] = useState(null);

  const [version, setVersion] = useState(null);
  const [canRollback, setCanRollback] = useState(false);

  useEffect(() => {
    if (display && selectedItem?.id) {
      setRequiredParams({
        id: selectedItem.id
      });
    }
  }, [display, selectedItem]);

  const columns: any = []; 
  columns.push(     
    {field: 'timeChange', header: t('common.time'),  matchMode: 'contains', dataType: 'date-time', filterType: 'date', width: 150},
    {field: 'result', header: t('catalog.priceUpdateResult'), width: 160, matchMode: 'contains'},
    {field: 'deviceCode', header: t('catalog.pumpCode'), width: 160, matchMode: 'contains'},
    {field: 'userCreate', header: t('common.editor'), width: 160, matchMode: 'contains'},
    {field: 'priceOld', header: t('catalog.oldPrice'), width: 120, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
      return FormatDisplay.number(rowData.priceOld, {maximumSignificantDigits: `${rowData.priceOld}`.length})
      }, style: {justifyContent: 'end'}
    },
    {field: 'price', header: t('catalog.newUnitPrice'), width: 120, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
      return FormatDisplay.number(rowData.price, {maximumSignificantDigits: `${rowData.price}`.length})
      }, style: {justifyContent: 'end'}
    },
    {field: 'errorUpdateIOT', header: t('catalog.iotPriceUpdateStatus'), minWidth: 160},
  );

  const {render: renderDataTable} = useDataTable({
    columns,
    indexColumnWidth: 40,
    getList: (params) => {
      return PetrolimexService.getListHistory(params).then(data => {
        if (setCanRollback) {
          setCanRollback(data && data.totalCount === 0);
        }
        return data;
      });
    },
    requiredParams,
    selectionMode: 'single'
  });
  return (
    <Dialog header={t('catalog.priceChangeHistory')} visible={display} style={{width: '80vw'}} position="top" onHide={() => setDisplay(false)}>
				<Fragment>
				 {renderDataTable()}
				</Fragment>

      <div className="flex justify-content-end mt-2">
        <Button label={t('common.close')} icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-outlined p-button-secondary p-button-sm"/>
      </div>
    </Dialog>
  );
}
